import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { DisclaimerProvider } from "./context/DisclaimerContext";
import { LanguageProvider } from "./context/LanguageContext";
import { ClinicProvider } from "./context/ClinicContext";
import { AutoTranslateProvider } from "./context/AutoTranslateContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Category from "./pages/Category";
import IllnessDetail from "./pages/IllnessDetail";
import Search from "./pages/Search";
import HijamaAtlas from "./pages/HijamaAtlas";
import About from "./pages/About";
import Services from "./pages/Services";
import Products from "./pages/Products";
import Contact from "./pages/Contact";
import Ruqyah from "./pages/Ruqyah";
import PaymentSuccess from "./pages/PaymentSuccess";
import Admin from "./pages/Admin";
import CertificatePurchase from "./pages/CertificatePurchase";
import DiagnosticQuestionnaire from "./pages/DiagnosticQuestionnaire";
import Academy from "./pages/Academy";
import QuranReader from "./pages/QuranReader";
import TajweedTeachers from "./pages/TajweedTeachers";
import ArabicLearn from "./pages/ArabicLearn";
import Tutors from "./pages/Tutors";
import TutorDetail from "./pages/TutorDetail";
import TutorApply from "./pages/TutorApply";
import TutorSession from "./pages/TutorSession";
import AcademyPass from "./pages/AcademyPass";
import Certificates from "./pages/Certificates";
import RecoverAccess from "./pages/RecoverAccess";
import Pronunciation from "./pages/Pronunciation";
import HowItWorks from "./pages/HowItWorks";
import TranslateDemo from "./pages/TranslateDemo";
import MySessions from "./pages/MySessions";
import AuthCallback from "./pages/AuthCallback";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import { AuthProvider } from "./context/AuthContext";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AutoTranslateProvider>
          <ClinicProvider>
            <DisclaimerProvider>
              <BrowserRouter>
                <AuthProvider>
                  <Routes>
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/auth/callback" element={<AuthCallback />} />
                    <Route element={<Layout />}>
                      <Route path="/" element={<Home />} />
                      <Route path="/category/:categoryId" element={<Category />} />
                      <Route path="/illness/:illnessId" element={<IllnessDetail />} />
                      <Route path="/search" element={<Search />} />
                      <Route path="/hijama-atlas" element={<HijamaAtlas />} />
                      <Route path="/services" element={<Services />} />
                      <Route path="/ruqyah" element={<Ruqyah />} />
                      <Route path="/ruqyah/diagnostic" element={<DiagnosticQuestionnaire />} />
                      <Route path="/academy" element={<Academy />} />
                      <Route path="/academy/how-it-works" element={<HowItWorks />} />
                      <Route path="/academy/translate-demo" element={<TranslateDemo />} />
                      <Route path="/academy/my-sessions" element={<MySessions />} />
                      <Route path="/academy/teachers" element={<TajweedTeachers />} />
                      <Route path="/academy/quran" element={<QuranReader />} />
                      <Route path="/academy/quran/:surahNum" element={<QuranReader />} />
                      <Route path="/academy/arabic" element={<ArabicLearn />} />
                      <Route path="/academy/tutors" element={<Tutors />} />
                      <Route path="/academy/tutors/apply" element={<TutorApply />} />
                      <Route path="/academy/tutors/:tutorId" element={<TutorDetail />} />
                      <Route path="/academy/session/:sessionId" element={<TutorSession />} />
                      <Route path="/academy/pronunciation" element={<Pronunciation />} />
                      <Route path="/academy/pass" element={<AcademyPass />} />
                      <Route path="/academy/certificates" element={<Certificates />} />
                      <Route path="/login" element={<Login />} />
                      <Route path="/register" element={<Register />} />
                      <Route path="/forgot-password" element={<ForgotPassword />} />
                      <Route path="/reset-password" element={<ResetPassword />} />
                      <Route path="/products" element={<Products />} />
                      <Route path="/contact" element={<Contact />} />
                      <Route path="/about" element={<About />} />
                      <Route path="/payment-success" element={<PaymentSuccess />} />
                      <Route path="/certificate-purchase/:token" element={<CertificatePurchase />} />
                    </Route>
                  </Routes>
                </AuthProvider>
              </BrowserRouter>
            </DisclaimerProvider>
          </ClinicProvider>
        </AutoTranslateProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
